import { useState } from 'react';

import { ListLayout } from '@ingrid/luterkort-react';

import { ToggleVisibilityButton } from '~src/components/ToggleVisibilityButton/ToggleVisibilityButton';

import { useUISchema } from '../hooks';
import { Schema } from '../queries';

interface Props {
  schemaId: string;
  schema: Schema;
  path?: string;
}

export function SchemaDisplayString({ schema, schemaId, path = '' }: Props) {
  const [showPassword, setShowPassword] = useState(false);

  const { widget } = useUISchema({ path, schemaId });

  if (schema.type !== 'string') {
    return null;
  }

  const value =
    widget === 'password' && !showPassword && schema.value
      ? String(schema.value).replace(/./g, '*')
      : (schema.value ?? '-');

  return (
    <ListLayout.Row>
      <ListLayout.Stack>
        <ListLayout.SecondaryText>{schema.title}</ListLayout.SecondaryText>
        <ListLayout.PrimaryText>{value}</ListLayout.PrimaryText>
      </ListLayout.Stack>

      {widget === 'password' && (
        <ListLayout.Actions>
          <ToggleVisibilityButton isShowing={showPassword} onClick={() => setShowPassword(prev => !prev)} />
        </ListLayout.Actions>
      )}
    </ListLayout.Row>
  );
}
